import { usePing } from "../../Hooks/Features/Inspectra/usePing";
import { Dialog } from 'primereact/dialog';
import DatePicker from 'react-multi-date-picker';
import { SkeletonContainer } from "../Loader/Loader";
import { MultiSelect } from "primereact/multiselect";
import PanelHeaderTemplate from "../CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate";
import { dateConvert, timePickerMuiCss } from "../../utils/Helper";
import { Calendar } from "primereact/calendar";
import _ from "underscore";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";

const PingAPI = ({ autopopData, projectChanged }) => {

    const { showPingData, setShowPingData, popupData, hoveredRange, loader, showFilter, setShowFilter, filterValues, setFilterValues, filterCount, time, setTime, handleDateRange, handleApplyFilters, handleDefaultFilters } = usePing({ projectChanged });

    return (
        <div className="inspectra-widget-container p-2">
            <div className="d-flex justify-content-between align-items-center">
                <div className="inspectra-widget-header">Ping API Status</div>
                <div className="text-primary inspectra-cursor inspectra-filter d-flex gap-1 align-items-center" onClick={() => setShowFilter(true)}><span className="inspectra-filter-count">{filterCount}</span>filters</div>
            </div>
            <div className="inspectra-date-string">{dateConvert(filterValues?.date?.from_date, "date-time-months")} - {dateConvert(filterValues?.date?.to_date, "date-time-months")}</div>
            {loader ? <div className="inspectra-widget-content ping-service-list" style={{ height: "87%" }}><SkeletonContainer /></div> :
                <div className="d-flex justify-content-center ps-1" style={{ height: "87%" }}>
                    <div className="ping-service-list inspectra-widget-content d-flex justify-content-center flex-wrap mt-1 align-items-center" style={{ height: "100%" }}>
                        {_.uniq(autopopData?.service_name)?.map(item => {
                            const maxSize = 50;
                            const minSize = 17;
                            const scalingCap = 60;
                            const clampedTotal = Math.min(_.uniq(autopopData?.service_name)?.length, scalingCap);
                            const size = maxSize - ((maxSize - minSize) * (clampedTotal - 1) / (scalingCap - 1));
                            return (
                                <div id={item} title={item} key={item} style={{ width: `${size}px`, height: `${size}px`, borderRadius: "3px", backgroundColor: "green", margin: '5px' }}></div>
                            )
                        })}
                    </div>
                </div>
            }

            <Dialog visible={showFilter} onHide={() => setShowFilter(false)} className="modal-small" draggable={false} header="Ping API Status Filters">
                <div>
                    <div className="d-flex gap-2 inspectra-calendar">
                        <div className="w50">
                            <div>Date: </div>
                            <div>
                                <DatePicker portal zIndex={99999} value={hoveredRange} onChange={handleDateRange} range rangeHover placeholder="Select Date Range" style={{ width: "100%" }} />
                            </div>
                        </div>
                        <div className="w45 d-flex gap-2 justify-content-between">
                            <div className="w50">
                                <div>From Time: </div>
                                <TimePicker value={time?.from || null} onChange={(e) => setTime((prev) => ({ ...prev, from: e }))} sx={{ ...timePickerMuiCss, backgroundColor: "white", margin: "2px 2px" }}
                                    slotProps={{
                                        textField: {
                                            label: undefined,
                                        }
                                    }}
                                />
                            </div>
                            <div className="w50">
                                <div>To Time: </div>
                                    <TimePicker value={time?.to || null} onChange={(e) => setTime((prev) => ({ ...prev, to: e }))} sx={{ ...timePickerMuiCss, backgroundColor: "white", margin: "2px 2px" }}
                                    slotProps={{
                                        textField: {
                                            label: undefined,
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="d-flex gap-2">
                        <div className="w50">
                            <div>Service:</div>
                            <MultiSelect options={autopopData?.service_name} placeholder="Service" value={filterValues?.service} onChange={(e) => setFilterValues((prev) => ({ ...prev, service: e.target.value }))} panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'service', filterValues?.service, () => setFilterValues((prev) => ({ ...prev, service: [] })))} filter filterInputAutoFocus />
                        </div>
                        <div className="w50">
                            <div>Server:</div>
                            <MultiSelect options={autopopData?.server} placeholder="Server" value={filterValues?.server} onChange={(e) => setFilterValues((prev) => ({ ...prev, server: e.target.value }))} panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'server', filterValues?.server, () => setFilterValues((prev) => ({ ...prev, server: [] })))} filter filterInputAutoFocus />
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mt-2">
                        <div className="text-primary c-pointer" onClick={() => handleDefaultFilters()}>Select default filters</div>
                        <button className="button btn-primary" onClick={() => handleApplyFilters()}>Apply</button>
                    </div>
                </div>
            </Dialog>

            <Dialog visible={showPingData} onHide={() => setShowPingData(false)} className="modal-large" draggable={false} header="Ping API Service Details">
                <div className="inspectra-ping-error">
                    {popupData?.map((item, index) => (
                        <div key={index} className="d-flex flex-column row-gap-1 p-2">
                            <div className="pb-3">
                                <span style={{ color: "rgb(43 192 98)" }}>$ </span>
                                <span style={{ color: "rgb(43 112 192)" }}>{new Date(item?.create_date).toLocaleString()}</span>
                                <span style={{ color: "rgb(255 17 163)" }}> [{item?.service_name}] </span>
                                <span style={{ color: "rgb(229 221 66)" }}>({item?.server}) </span>
                                <span style={{ color: "rgb(231 54 35)" }}>{item?.response}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </Dialog>

        </div>
    )
}

export default PingAPI;